import { actionCreators as nodeActionCreators } from '../../../ducks/resource-nodes';
import { selectors as uploadSelectors } from '../../../ducks/uploads';

export const clearParentResourceUploads = ({ getState, dispatch, action }) => {
  const state = getState();
  const parentResource = action.payload.parentResource;

  const uploads = uploadSelectors.getUploadsByParentResource(
    state,
    parentResource
  );

  uploads.forEach((u) => {
    dispatch(nodeActionCreators.disposeResource('file-upload', u.id, true));
  });
};
